import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
@Injectable()
export class AuthInterceptorInterceptor implements HttpInterceptor {

  constructor() {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const token = '2022MOPABIFDWJFRNFRPD08P';
    let request = req;
    request = req.clone({
      setHeaders: {
        'x-token': token
      }
    });
    // Guardamos la IP original y la alternativa
    const originalIp ="localhost";
    const backupIp = window.location.hostname;
    const newUrl = request.url.replace(originalIp, backupIp);
    const clonedReq = request.clone({ url: newUrl });
    return next.handle(clonedReq); // Reenviamos a la nueva IP
  }
}
